import CalcHeader from "./CalcHeader";
import ChooseNumOfNums from "./ChooseNumNums";
import React, { useState, useEffect } from "react";
import TireSizes from "../TireSizes";
import CalcForm from "./CalcBody";
import "../main.css";
import { BASE_URL } from "../apiConfig";
function Calculator() {
  const [submissions, setSubmissions] = useState(null);
  const [numSubmits, setNumSubmits] = useState(null);
  const [tireSizes, setTireSizes] = useState(null);
  const [tftInfo, setTftInfo] = useState(null);

  useEffect(() => {
    async function initTireFillsAndSubmissions() {
      async function setTireSizesFromDb() {
        const tireSizesRes = await fetch(`${BASE_URL}/tireSizes`);
        const tireSizesArr = await tireSizesRes.json();
        setTireSizes(new TireSizes(tireSizesArr.items));
      }

      async function setTireSizeSubmissionsFromDb() {
        try {
          const submissionsRes = await fetch(`${BASE_URL}/tireSizeSubmissions`);
          const tireSizeSubmissions = await submissionsRes.json();
          console.log("submissions", tireSizeSubmissions.items);
          setSubmissions(tireSizeSubmissions.items);
          setNumSubmits(calculateNumSubmissions(tireSizeSubmissions.items));
        } catch (err) {
          console.log("list subs", err);
          // throw err;
        }
      }

      try {
        const tireSizesRes = setTireSizesFromDb();
        const tireSizeSubmissionRes = setTireSizeSubmissionsFromDb();
        await Promise.all([tireSizesRes, tireSizeSubmissionRes]);
      } catch (err) {
        console.log("calc err", err);
        // throw err;
      }
    }

    initTireFillsAndSubmissions();
  }, []);

  const addTireSizeSubmit = async (vals, matchType) => {
    const matchingSubmission = submissions.filter((tire) =>
      TireSizes.isSameTireSize(vals, tire)
    );
    const curDate = new Date();
    const curDateStr = curDate.toISOString();
    if (matchingSubmission.length === 1) {
      const details = {
        id: matchingSubmission[0].id,
        submissionsTs: [...matchingSubmission[0].submissionsTs, Date.now()],
        matchType,
        updatedAt: curDateStr,
      };
      await fetch(`${BASE_URL}/tireSizeSubmissions/${details.id}`, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        method: "PUT",
        body: JSON.stringify(details),
      });
    } else {
      const newData = {
        ...vals,
        submissionsTs: [Date.now()],
        updatedAt: curDateStr,
        createdAt: curDateStr,
      };
      delete newData.matchType;
      newData.matchType = matchType;
      const res = await fetch(`${BASE_URL}/tireSizeSubmissions`, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        method: "POST",
        body: JSON.stringify(newData),
      });
      console.log("tire size submitted", res.data);
    }
  };

  function calculateNumSubmissions(submissions) {
    if (submissions?.length > 0) {
      return submissions.reduce(
        (acc, cur) => acc + cur?.submissionsTs?.length,
        0
      );
    } else {
      return 0;
    }
  }

  return (
    <div className="justify-content-center vertical-center">
      <ChooseNumOfNums setTftInfo={setTftInfo} tftInfo={tftInfo} />
      {tftInfo === null ? (
        <div></div>
      ) : (
        <CalcForm
          tireSizes={tireSizes}
          numSubmits={numSubmits}
          addTireSizeSubmit={addTireSizeSubmit}
          notation={tftInfo.notation}
          msrmtNames={tftInfo.msrmtNames}
          initValues={tftInfo.initValues}
        />
      )}
      {tftInfo === null ? <div></div> : <CalcHeader tftInfo={tftInfo} />}
    </div>
  );
}

export default Calculator;
